import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { usePerformanceDetailReport } from "@/hooks/reports/performance-detail-report.hook";
import {
  Building,
  ClipboardTick,
  Global,
  Layer,
  PathTool2,
} from "iconsax-react";
import { useParams } from "react-router-dom";

const ResultsSummary = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const { quizId } = useParams();

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quizId || "",
  });

  const {
    data: report,
    error: reportError,
    isLoading: isReportLoading,
  } = usePerformanceDetailReport({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quiz?.id || "",
  });

  if (reportError) {
    throw reportError;
  }

  if (isReportLoading) {
    return (
      <Skeleton
        style={{ width: "100%", height: "336px" }}
        className="bg-gray-300"
      />
    );
  }

  if (!report) {
    return null;
  }

  const items = [
    {
      label1: "Empresas",
      label2: "participantes",
      quantity: report.summary.totalApplicants,
      icon: <Building size="28" color="#615CB7" />,
    },
    {
      label1: "Sectores",
      label2: "participantes",
      quantity: report.summary.totalSectorsParticipants,
      icon: <Global size="28" color="#615CB7" />,
    },
    {
      label1: "Temas",
      label2: "evaluados",
      quantity: report.summary.totalTopicsEvaluated,
      icon: <Layer size="28" color="#615CB7" />,
    },
    {
      label1: "Preguntas ASG",
      label2: "evaluados",
      quantity: report.summary.totalQuestionsEvaluated,
      icon: <PathTool2 size="28" color="#615CB7" />,
    },
  ];

  return (
    <div className="rounded-xl bg-[#171632] py-7">
      <div className="flex flex-col items-center gap-3">
        <ClipboardTick size="42" color="white" />
        <p className="text-2xl font-semibold text-white">
          Resumen EGS {quiz?.edition.year}
        </p>
      </div>

      <p className="mt-2 px-5 text-center font-light text-white">
        Estos números representan más que métricas. ¡Son el resultado de un
        compromiso que tú ayudaste a liderar!
      </p>

      <div className="mt-5 flex items-center justify-center gap-5 px-5">
        {items.map((result, index) => (
          <div
            key={index}
            className="flex h-[142px] w-[210px] flex-col justify-between rounded-3xl bg-[#E3E3F3] p-6"
          >
            <div className="flex items-center">
              <p className="flex-1 text-lg font-bold text-[#414D55]">
                {result.quantity}
              </p>
              {result.icon}
            </div>
            <p className="font-light text-[#414D55]">
              <span className="block">{result.label1}</span>
              <span className="block">{result.label2}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultsSummary;
